import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import SupplierReviewModal from './SupplierReviewModal';

export default class SupplierReviewsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {showModal: false};

        this.onModalShow = this.onModalShow.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
    }

    onModalShow() {
        this.setState({showModal: true});
    }

    onModalClose() {
        this.setState({showModal: false});
    }

    render() {
        const {supplierId} = this.props;

        return (
            <div>
                <button className="btn btn-primary" onClick={this.onModalShow}>
                    <i className="fa fa-fw fa-edit"></i>
                    {window.__js_bid_reviews.supplier_review}
                </button>
                <SupplierReviewModal
                    show={this.state.showModal}
                    onClose={this.onModalClose}
                    supplierId={supplierId}
                />
            </div>
        );
    }
}

const element = document.getElementById('supplier-reviews');

if (element) {
    const supplierId = element.getAttribute('data-supplier-id');

    ReactDOM.render(
        <SupplierReviewsComponent
            supplierId={supplierId}
        />,
        element
    );
}